import {ref} from "vue";

export default new class Fullscreen {
    readonly isFullscreen = ref(false)

    constructor() {
        // 绑定方法
        this.handleFullscreenChange = this.handleFullscreenChange.bind(this)
        this.handleKeydown = this.handleKeydown.bind(this)

        // 初始检查状态
        this.checkFullscreenStatus()

        // 添加事件监听器
        document.addEventListener('fullscreenchange', this.handleFullscreenChange)
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
        document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
        document.addEventListener('MSFullscreenChange', this.handleFullscreenChange)
        document.addEventListener('keydown', this.handleKeydown)
    }

    private checkFullscreenStatus() {
        // 使用类型断言解决类型错误
        const doc = document as Document & {
            webkitFullscreenElement?: Element
            mozFullScreenElement?: Element
            msFullscreenElement?: Element
        }

        this.isFullscreen.value = !!(
            doc.fullscreenElement ||
            doc.webkitFullscreenElement ||
            doc.mozFullScreenElement ||
            doc.msFullscreenElement
        )
    }

    // 切换全屏
    toggleFullscreen = () => {
        if (!this.isFullscreen.value) {
            // 进入全屏
            const element = document.documentElement

            const elem = element as HTMLElement & {
                webkitRequestFullscreen?: () => Promise<void>
                mozRequestFullScreen?: () => Promise<void>
                msRequestFullscreen?: () => Promise<void>
            }

            if (elem.requestFullscreen) {
                elem.requestFullscreen()
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen()
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen()
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen()
            }
        } else {
            // 退出全屏
            const doc = document as Document & {
                webkitExitFullscreen?: () => Promise<void>
                mozCancelFullScreen?: () => Promise<void>
                msExitFullscreen?: () => Promise<void>
            }

            if (doc.exitFullscreen) {
                doc.exitFullscreen()
            } else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen()
            } else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen()
            } else if (doc.msExitFullscreen) {
                doc.msExitFullscreen()
            }
        }
    }

    private handleFullscreenChange() {
        this.checkFullscreenStatus()
    }

    private handleKeydown(event: KeyboardEvent) {
        // ESC键退出全屏
        if (event.key === 'Escape' && this.isFullscreen.value) {
            this.toggleFullscreen()
        }
        // F11键切换全屏
        if (event.key === 'F11') {
            event.preventDefault()
            this.toggleFullscreen()
        }
    }
}